import { formatDateTime } from '../../lib/format'
import type { PendingJob } from '../../lib/pendingJob'
import { CONDITION_WORDS } from '../../lib/recordings'

/**
 * The pending-upload card's one sentence, in its own module so the mirror's
 * processing banner says the same thing in the same words (Sprint 1.9.9) rather
 * than a second phrasing of one fact.
 */
export function pendingSentence(pending: PendingJob): string {
  return `Started ${formatDateTime(pending.startedAt)} · ${CONDITION_WORDS[pending.condition]} ${pending.condition}. Record follows it to its result.`
}
